import api from "PFCore/api";
import { Id } from "PFTypes";

export type MarkActivityAsReadResponse = {
  id: Id;
  activityId: Id;
  profileId: Id;
};

export const markActivityAsRead = (activityId: Id) =>
  api<MarkActivityAsReadResponse>({
    url: "marketplace/read",
    method: "POST",
    data: {
      activityId
    }
  });

export const markActivityAsUnread = (activityId: Id) =>
  api<void>({
    url: `marketplace/read/${activityId}`,
    method: "DELETE"
  });
